var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pui-common-select',{ref:"editor",attrs:{"value":_vm.getValue,"disabled":_vm.editor.disabled,"taggable":false,"multiple":false,"options":_vm.editor.options,"display":_vm.editor.display},on:{"select":_vm.onValueChanged,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }